import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import customAxios from '../API/customAxios';
import List from "@material-ui/core/List";
import { logoutRequest } from "../../authConfig";
import { useIntl } from 'react-intl';
import { useHistory } from "react-router-dom";

export default function belowListItems() {
    const intl = useIntl();
    const { instance } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const history = useHistory();
    const handleLogout = () => {
        // get backend access token
        customAxios.get("/logout").then(
            (response) => {
                localStorage.removeItem('employee_name');
                localStorage.removeItem('token');
                localStorage.removeItem('staff_duty');
                localStorage.removeItem('selectedIndex');
                localStorage.removeItem('isApplicationOpen');
                localStorage.removeItem('isMyRequestOpen');
                localStorage.removeItem('isLeaveApprovalOpen');
                localStorage.removeItem('isHRAdminOpen');
                localStorage.removeItem('isHrAdminRole');
                localStorage.removeItem('department_id');

                // LOGOUT AD
                if (instance && isAuthenticated) {
                    instance.logoutRedirect(logoutRequest).catch(e => {
                        console.error(e);
                    });
                } else {
                    history.push("/login");
                }
            },
            // COOKIE ERROR
            (error) => {
                console.error(error);
            });
    }


    return (
        <List>
            <ListItem button onClick={() => handleLogout()}>
                <ListItemIcon>
                    <ExitToAppIcon style={{ color: '#232f3e' }} />
                </ListItemIcon>
                <ListItemText primary={intl.formatMessage({ id: 'navigation.logout' })} />
            </ListItem>
        </List>
    );

}